/**
 * Grid of the last 24 months as toggleable chips. Extracted from Products.jsx
 * (Feb 2026). Value is an array of "YYYY-MM" strings.
 */
export function MultiMonthSelector({ value, onChange, lang }) {
  const months = (() => {
    const arr = [];
    const now = new Date();
    for (let i = 0; i < 24; i++) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      arr.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`);
    }
    return arr;
  })();

  const monthName = (ym) => {
    const [y, m] = ym.split("-");
    const names = lang === "es"
      ? ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
      : ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${names[parseInt(m, 10) - 1]} ${y.slice(-2)}`;
  };

  const toggle = (ym) => {
    if (value.includes(ym)) onChange(value.filter((m) => m !== ym));
    else onChange([...value, ym]);
  };

  const byYear = months.reduce((acc, ym) => {
    const y = ym.slice(0, 4);
    if (!acc[y]) acc[y] = [];
    acc[y].push(ym);
    return acc;
  }, {});

  return (
    <div className="pt-2 border-t border-[var(--border-color)] space-y-2" data-testid="products-multi-month-selector">
      {Object.entries(byYear).sort((a, b) => b[0].localeCompare(a[0])).map(([year, list]) => (
        <div key={year} className="flex items-center gap-2 flex-wrap">
          <span className="text-[10px] uppercase tracking-wider text-[var(--text-muted)] w-12 font-mono-num">{year}</span>
          {list.map((ym) => {
            const sel = value.includes(ym);
            return (
              <button
                key={ym}
                type="button"
                onClick={() => toggle(ym)}
                data-testid={`products-month-chip-${ym}`}
                className={`px-2 py-1 rounded text-[11px] font-medium transition-colors border ${
                  sel
                    ? "bg-[var(--brand-accent)] text-white border-[var(--brand-accent)]"
                    : "bg-[var(--surface)] text-[var(--text-secondary)] border-[var(--border-color)] hover:border-[var(--brand-accent)]"
                }`}
              >
                {monthName(ym)}
              </button>
            );
          })}
        </div>
      ))}
      <div className="flex items-center gap-2 text-xs">
        <button
          type="button"
          onClick={() => onChange([])}
          className="text-[var(--text-muted)] hover:text-[var(--text-primary)] underline"
          data-testid="products-months-clear"
        >
          {lang === "es" ? "Limpiar" : "Clear"}
        </button>
        <button
          type="button"
          onClick={() => {
            const y = new Date().getFullYear();
            const all = [];
            for (let i = 0; i < 12; i++) all.push(`${y}-${String(i + 1).padStart(2, "0")}`);
            onChange(all);
          }}
          className="text-[var(--text-muted)] hover:text-[var(--text-primary)] underline"
          data-testid="products-months-this-year"
        >
          {lang === "es" ? "Todo este año" : "All this year"}
        </button>
      </div>
    </div>
  );
}
